import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal as ModalContainer} from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';

class Modal extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
            canSave:false,
		}

	}

	componentDidMount(){
        this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(){		
		this.setState({
			show: true
		});
	}

	handleClose(){
		this.setState({
			show: false,
		});

		this.props.clear();
	}

	render(){
		const {t} = this.props;

		return (
			<ModalContainer 
                backdrop="static" 
                keyboard={false}
                show={this.state.show}
                onHide={this.handleClose}
				className="modal-biometrics"
            >
		       	{this.props.title !== "" &&
				   <ModalContainer.Header closeButton>
						<ModalContainer.Title>{this.props.title}</ModalContainer.Title>
					</ModalContainer.Header>
				}
		        <ModalContainer.Body>
		        	{this.props.children}
		        </ModalContainer.Body>
		        <ModalContainer.Footer>
					{this.props.actionBtn && 
						<FlatButton 
							primary
							label={this.props.label}
							onClick={()=>this.props.action()}
						/>
					}

		        	<FlatButton 
						primary={true} 
						label={t('content.generics.buttons.close')}  
						onClick={this.handleClose}
					/>
		        </ModalContainer.Footer>
		    </ModalContainer>
		)
	}
}
export default translate('translations') (Modal);

Modal.defaultProps = {
	actionBtn:false,
	size:''
};